import SearchQueryBase from "@grindex-client/components/Search/search-query-base.class";

export default class FreeTextSearchQuery extends SearchQueryBase {
	constructor() {
		super();
	}
}
